export function getDashboardRoute(role) {
  if (role === "worker") return "/worker-dashboard";
  if (role === "shop_owner") return "/shop-owner-dashboard";
  if (role === "admin") return "/admin-dashboard";
  if (role === "customer") return "/customer-dashboard";
  return "/";
}

export function getPostLoginRoute(profile) {
  return getDashboardRoute(profile?.role);
}

export function getSettingsRoute(profile) {
  if (!profile?.role) return "/login";
  return "/settings";
}

export function getUnauthorizedRedirectRoute(profile) {
  if (!profile?.role) return "/";
  return getDashboardRoute(profile.role);
}

export function canAccessCustomerNavigation(role) {
  return role === "customer" || !role;
}

export function buildWorkerDetailsRoute(workerId) {
  return `/worker-details?workerId=${workerId}`;
}

export function buildVendorDetailsRoute(shopId) {
  return `/vendor-details?shopId=${shopId}`;
}

export function buildBookingRoute(workerId) {
  return `/booking?workerId=${workerId}`;
}

export function shouldRequireAuthForCheckout(profile) {
  return !profile;
}

export function getSlotStatusTone(statusLabel) {
  if (statusLabel === "Available") return "success";
  if (statusLabel === "Filling Fast") return "warning";
  if (statusLabel === "Not Available") return "danger";
  return "neutral";
}
